var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoodle1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 72,
    viewBox: "0 0 74 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.9123 51.1167C49.9123 51.1167 49.6554 51.3188 49.4818 51.4234C48.44 52.051 47.3375 51.9109 46.9985 51.0743C41.8583 38.3939 34.0481 27.6057 23.857 18.9141C23.2231 18.3735 23.3563 17.1816 24.2447 16.3389C25.0879 15.4998 26.339 15.2191 27.0216 15.8014C37.5053 24.7424 45.476 35.836 50.7768 48.8218C51.0599 49.5265 50.6793 50.4654 49.9158 51.1619L49.9123 51.1167Z",
    fill: "#605DBA",
    stroke: "#605DBA",
    strokeWidth: 0.83,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6306 34.9169C64.6306 34.9169 64.4118 35.0251 64.3214 35.0322C63.1678 35.396 62.0475 35.0302 61.8406 34.1377L56.1221 8.9616C55.9151 8.06916 56.6988 7.05299 57.8524 6.68919C59.006 6.32538 60.1263 6.69125 60.3333 7.58369L66.0518 32.7598C66.2516 33.5619 65.5963 34.4771 64.6306 34.9169V34.9169Z",
    fill: "#605DBA",
    stroke: "#605DBA",
    strokeWidth: 0.85,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2893 61.4756C33.2893 61.4756 33.2132 61.6634 33.13 61.7609C32.5342 62.8531 31.5233 63.2965 30.8062 62.8533L10.876 48.8879C10.2005 48.396 10.1006 47.1316 10.6512 46.043C11.247 44.9508 12.2579 44.5074 12.975 44.9505L32.9539 58.9575C33.5807 59.4078 33.7115 60.488 33.2893 61.4756Z",
    fill: "#605DBA",
    stroke: "#605DBA",
    strokeWidth: 0.82,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoodle1);
export default __webpack_public_path__ + "static/media/doodle1.2635ef938a3c671646c89ec6f5509612.svg";
export { ForwardRef as ReactComponent };